import {
  fetchEspecialidadesSelect,
  fetchSeguroSaludSelect,
  fetchTipoCoberturaSelect,
  fetchTipoServicioSelect,
  searchDoctoresByTerm
} from "@/shared/services";

import { pacientesService } from "@/views/admision/services";

import { establecimientosService } from "@/views/administracion/services";

export const loadEspecialidadesOpts = async () => {
  const especialidadesBackend = await fetchEspecialidadesSelect();

  const especialidadesExtras = [
    { value: "*", text: "TODOS", codigo: "*" },
    { value: "ge", text: "GENERAL Y ESPECIALIDADES", codigo: "ge" },
    { value: "e", text: "SOLO ESPECIALIDADES", codigo: "e" },
    { value: "g", text: "TODO ODONTOLOGIA", codigo: "g" },
  ];

  return [...especialidadesExtras, ...especialidadesBackend];
};

export const loadEstablecimientosOpts = async () => {
  const establecimientosBackend = await establecimientosService.getForSelect();

  return [...establecimientosBackend];
};

export const loadTipoSegurosOpts = async () => {
  const tipoSegurosBackend = await fetchSeguroSaludSelect();

  const tipoSegurosExtras = [
    { value: "*", text: "TODOS", codigo: "*" },
    { value: "*b", text: "TODO BASE", codigo: "*b" },
    { value: "*c", text: "TODO CAMPESINO", codigo: "*c" },
    { value: "*m", text: "TODO MONTEPIO", codigo: "*m" },
  ];

  return [...tipoSegurosExtras, ...tipoSegurosBackend];
};

export const loadTipoCoberturaOpts = async () => {
  const itemsBackend = await fetchTipoCoberturaSelect();

  const tipoCoberturaExtras = [
    { value: "*", text: "TODOS", codigo: "*" },
    { value: "tisfa", text: "ISSFA 100%", codigo: "tisfa" },
    { value: "tispol", text: "ISSPOL 100%", codigo: "tispol" },
  ];

  return [...tipoCoberturaExtras, ...itemsBackend];
};

export const loadDoctoresOpts = async (variable) => {
  console.log("Loading doctors with variable:", variable);
  const itemsBackend = await searchDoctoresByTerm(variable);

  return [...itemsBackend];
};

export const loadPacientesOpts = async (variable) => {
  const itemsBackend = await pacientesService.searchPacientesByTerm(variable);

  return [...itemsBackend];
};

export const loadTipoServiciosOpts = async () => {
  const itemsBackend = await fetchTipoServicioSelect();


  const itemsBackendMapped = itemsBackend.map((item) => {
    if (item.text === "C/EXT") return { ...item, text: "CONSULTA EXTERNA" };

    if (item.text === "LAB") return { ...item, text: "LABORATORIO" };

    if (item.text === "PRO/ESP") return { ...item, text: "PROCEDIMIENTOS" };

    return item;
  });

  const tipoServicioExtras = [
    { value: "*", text: "TODOS" },
    { value: "*m", text: "MEDICAMENTO" },
    { value: "*i", text: "IMAGENES" },
    { value: "*l", text: "LABORATORIO" },
    { value: "*a", text: "ATENCIONES" },
  ];

  return [...tipoServicioExtras];
};
